<template>
  <div class="dimension-table">
    <QS-h4-title title="运营情况" :content="dateText" />
    <QS-common-table
      :max-height="400"
      :data="tableData"
      :columns="columns"
      :pagination="false"
    />
  </div>
</template>
<script>
import config from './config'

export default {
  props: {
    dateText: {
      type: String,
      default: '',
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const { columns } = config.call(this)
    return {
      columns,
    }
  },
}
</script>
<style scoped lang='scss'>
.dimensionTable{
  margin-top: 24px;
}
</style>
